import { mergeMap } from 'rxjs/operators';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PriceFilteringRuleAction } from '../priceFilteringRule.action';

type IDependencies = IClientApiDependencySegment;

export const exportPriceFilteringRulesEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringRuleAction.exportFile.started),
  mergeMap((params) => {
    return dependencies.api.exportPriceFilteringRules().pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          PriceFilteringRuleAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
